import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeContextProvider from './contexts/ThemeContext'
import { ThemeProvider, createTheme } from '@mui/material/styles'


import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const muiTheme = createTheme();

ReactDOM.render(
  <ThemeProvider theme={muiTheme}>
    <ThemeContextProvider>
      <App />
    </ThemeContextProvider>
  </ThemeProvider>,
  document.getElementById('root')
);


reportWebVitals();
